(function () {
    "use strict";
    const adminbar = document.getElementById('wpadminbar');

    document.addEventListener('click', function (e) {
        // First accordion handler
        const accordionHeader = e.target.closest('.product-tabs--accordion .woocommerce-Tabs-panel .tabs-accordion-header');
        if (accordionHeader) {
            const currentTab = accordionHeader.closest('.woocommerce-Tabs-panel');
            if (currentTab) {
                const accordionContainer = accordionHeader.closest('.product-tabs--accordion');
                if (accordionContainer) {
                    accordionContainer.querySelectorAll('.woocommerce-Tabs-panel').forEach(panel => {
                        if (panel !== currentTab) {
                            panel.style.display = 'none';
                        }
                    });
                }
                if (currentTab.style.display === 'none' || currentTab.style.display === '') {
                    currentTab.style.display = 'block';
                } else {
                    currentTab.style.display = 'none';
                }
            }
            return;
        }

        // Click handler for tab anchor
        const tabAnchor = e.target.closest('.woocommerce-tabs.woocommerce-tabs--display-all ul.wc-tabs li a');
        if (tabAnchor) {
            if (!e.isTrusted) {
                return;
            }
            const targetId = tabAnchor.getAttribute("href");
            const targetTab = document.querySelector(targetId);
            if (targetTab) {
                const tabsUl = tabAnchor.closest('ul.wc-tabs');
                const tabsHeight = tabsUl ? tabsUl.offsetHeight : 0;
                const rect = targetTab.getBoundingClientRect();
                const scrollTop = rect.top + window.scrollY - tabsHeight;
                let finalScrollTop = scrollTop;
                if (adminbar) {
                    finalScrollTop -= adminbar.offsetHeight;
                }
                window.scrollTo({
                    top: finalScrollTop - 50,
                    behavior: 'smooth'
                });
            }
        }
    });

    window.addEventListener("scroll", function () {
        const tabsContainer = document.querySelector('.woocommerce-tabs');
        if (!tabsContainer || !tabsContainer.classList.contains('woocommerce-tabs--display-all')) return;

        const tabs = document.querySelector(".woocommerce-tabs ul.wc-tabs");
        if (!tabs) return;

        const tabsPanel = Array.from(document.querySelectorAll(".woocommerce-Tabs-panel"));
        const tabsHeight = tabs.offsetHeight;
        const currentScroll = window.scrollY;

        for (let i = tabsPanel.length - 1; i >= 0; i--) {
            const panel = tabsPanel[i];
            const rect = panel.getBoundingClientRect();
            let scrollTop = rect.top + window.scrollY - tabsHeight - 70;
            if (adminbar) {
                scrollTop -= adminbar.offsetHeight;
            }

            if (currentScroll > scrollTop) {
                const currentTabId = panel.getAttribute('id');
                const activeLi = tabs.querySelector('.active');
                if (activeLi) {
                    activeLi.classList.remove('active');
                }
                const link = tabs.querySelector(`[href="#${currentTabId}"]`);
                if (link && link.parentElement) {
                    link.parentElement.classList.add('active');
                }
                break;
            }
        }
    });
})();
